export const emptyFolderPlaceholderName = "EMPTY_FOLDER_PLACEHOLDER";
export const recyclePathSegment = "__RECYCLE_PATH";
